<template lang="pug">
.reserve-page.flex.column.gap-20
  .search-bar.flex.align-center.justify-space-between
    .filter.flex.align-end.gap-10
      .column.flex.column.align-start.gap-4
        .title 預約時間
        el-date-picker.date-range-input(
          @change="changeDate"
          v-model="times"
          type="daterange"
          range-separator="至")
      .column.flex.column.align-start.gap-4
        .title 館別
        place-selector.place-input(v-model="branch", @input="changeBranch")
      .column.flex.column.align-start.gap-4
        .title 專案
        el-select(
          @change="changeProject"
          v-model="project" filterable clearable)
          el-option-group(label="無專案")
            el-option(value="null", label="無專案")
          el-option-group(
            v-for="group in organizations"
            v-if="group.public"
            :key="group.id"
            :label="group.name")
            el-option(
              v-for="p in group.projects"
              :key="p.id"
              :label="`${group.name} - ${p.name}`"
              :value="`${p.id}`")
              span {{ p.name }}
      .column.flex.column.align-start.gap-4
        .title 隱藏已取消的預約
        el-checkbox(border, v-model="hideCancel", @change="loadData") 隱藏
    el-button(
      type="primary", icon="el-icon-plus"
      @click="$refs.appointmentNew.$emit('show')"
      id="add-reserve-btn"
      ) 新增預約
  template
    .table.flex
      el-table(:data="reserveList")
        el-table-column(label="類型", width="50")
          template(slot-scope="scope")
            span(v-if="scope.row.appointment_type === 'individual'") 個別
            span(v-if="scope.row.appointment_type === 'couple'") 伴侶
            span(v-if="scope.row.appointment_type === 'parent'") 親子
            span(v-if="scope.row.appointment_type === 'family'") 家庭
            span(v-if="scope.row.appointment_type === 'earlytreatment'")
              template(v-if="(scope.row.partners || []).length > 0") 早療團體
              template(v-else) 早療
            span(v-if="scope.row.appointment_type === 'supervise'") 督導
        el-table-column(label="議題", width="50")
          template(slot-scope="scope")
            span(:class="{'cancel-text': scope.row.isCancelled}")
              template(v-if="scope.row.main_requirement_type === 'mental'") 心理
              template(v-else-if="scope.row.main_requirement_type === 'law'") 法律
              template(v-else-if="scope.row.main_requirement_type === 'finance'") 財務
              template(v-else-if="scope.row.main_requirement_type === 'management'") 組織
              template(v-else-if="scope.row.main_requirement_type === 'medical'") 健康
              template(v-else) --
        el-table-column(label="個案姓名")
          template(slot="header", slot-scope="scope")
            .flex.align-center
              template(v-if="userSearch")
                user-picker(
                  size="mini"
                  @clear="setUserSearch(undefined)"
                  @input="setUserSearch")
              template(v-else)
                span 個案姓名
                i.el-icon-search.clickable(@click="userSearch = true")
          template(slot-scope="scope")
            .td-name.flex.align-center.justify-space-between
              .names.flex.align-center.wrap
                .name.text-clickable.flex.align-center.gap-4(
                  :class="{'text-placeholder': scope.row.isCancelled}"
                  @click="showCase(scope.row.user)"
                  )
                  name-span(:patient="scope.row.user", :isCancelled="scope.row.isCancelled")
                template(v-if="scope.row.type !== 'parent'")
                  template(v-for="(p, idx) in scope.row.partners")
                    span(:key="`dot-${idx}`") 、
                    .name.text-clickable.flex.align-center.gap-4(
                      :key="p.id"
                      :class="{'text-placeholder': scope.row.isCancelled}"
                      @click="showCase(p)"
                      )
                        name-span(:patient="p", :isCancelled="scope.row.isCancelled")
                template(v-else)
                  template(v-for="(p, idx) in scope.row.partners")
                    .name.flex.align-center.clickable.ml-4(
                      :key="p.id"
                      @click="showCase(p)"
                      :class="{'cancel-text': scope.row.isCancelled}"
                      )
                      span (
                      name-span(
                        :showSubType="scope.row.subtype"
                        :patient="p", :isCancelled="scope.row.isCancelled", no-copy)
                      span )
              .note(v-if="scope.row.note")
                el-tooltip(:content="scope.row.note", placement="right")
                  i.el-icon-chat-dot-round.clickable
        el-table-column(label="標記", class-name="td-tags")
          template(slot-scope="scope")
            template(v-for="n in scope.row.tags")
              el-tag(v-if="scope.row.isCancelled" :key="n", type="info") {{ n }}
              el-tag(v-else :key="n") {{ n }}
            el-select.selector-no-text(
              multiple, v-model="scope.row.tags", @change="updateBranchTags(scope.row)")
              el-option(
                v-for="tag in tags",
                v-if="tag.public",
                :key="tag.name", :label="tag.name", :value="tag.name")
        el-table-column(label="預約時間與時長", width="210")
          template(slot-scope="scope")
            .td-time.flex.align-center
            span(:class="{'cancel-text': scope.row.isCancelled}")
              span {{ $timestampToDateTimeMinuteWithDay(scope.row.start_at) }}
            span(:class="{'cancel-text': scope.row.isCancelled}") &nbsp;({{ scope.row.length }} hr)
        el-table-column(label="型態", width="50")
          template(slot-scope="scope")
            span(
              :class="{'cancel-text': scope.row.isCancelled}"
              v-if="scope.row.location_type === 'inhouse'") 實體
            span(
              :class="{'cancel-text': scope.row.isCancelled}"
              v-else-if="scope.row.location_type === 'phone'") 電話
            span(
              :class="{'cancel-text': scope.row.isCancelled}"
              v-else) 遠距
        el-table-column(label="預約空間", width="120")
          template(slot-scope="scope")
            span(:class="{'cancel-text': scope.row.isCancelled}") {{ scope.row.room.branch.name }}
            span(:class="{'cancel-text': scope.row.isCancelled}") &nbsp;{{ scope.row.room.name }}
        el-table-column(label="專業人士", width="130")
          template(slot="header", slot-scope="scope")
            .flex.align-center
              template(v-if="proSearch")
                pro-picker(
                  show-hide
                  size="mini"
                  ref="proPicker"
                  @clear="setProFilter(undefined)"
                  @input="setProFilter")
              template(v-else)
                span 專業人士
                i.el-icon-search.clickable(@click="editProSearch")
          template(slot-scope="scope")
            pro-badge(
              :class="{'cancel-text': scope.row.isCancelled}"
              :professional="scope.row.professional")
        el-table-column(label="預約價位", width="100")
          template(slot-scope="scope")
            span(:class="{'cancel-text': scope.row.isCancelled}") NT ${{ scope.row.price }}
        el-table-column(label="支付記錄", width="150")
          template(slot-scope="scope")
            template(v-if="scope.row.project")
              span(:class="{'cancel-text': scope.row.isCancelled}") {{ scope.row.projectName }}
            template(v-else-if="scope.row.isCancelled")
              .flex.align-center.gap-6
                span(:class="{'cancel-text-with-event': scope.row.isCancelled}")
                  template(v-if="scope.row.payment === '3rdparty'")
                    span 申請退款中
                    el-popover(trigger="hover", placement="top-start"
                      title="藍新支付ID", :content="scope.row.newebpay_trx_id")
                      i.el-icon-info(slot="reference")
                  template(v-else-if="scope.row.payment === '3rdparty_refunded'")
                    span 申請退款中
                    el-popover(trigger="hover", placement="top-start"
                      title="藍新支付ID", :content="scope.row.newebpay_trx_id")
                      i.el-icon-info(slot="reference")
                  template(v-else-if="scope.row.payment === '3rdparty_refunded_finish'")
                    span 完成退款
                    el-popover(trigger="hover", placement="top-start"
                      title="藍新支付ID", :content="scope.row.newebpay_trx_id")
                      i.el-icon-info(slot="reference")
                  template(v-else) ---
            template(v-else)
              .flex.align-center.gap-6
                span.danger-color(v-if="scope.row.payment === 'notpaid'") 尚未支付
                span(v-else-if="scope.row.payment === 'cash'") 現金支付
                span(v-else-if="scope.row.payment === '3rdparty'")
                  span 藍新金流
                  el-popover(trigger="hover", placement="top-start"
                    title="藍新支付ID", :content="scope.row.newebpay_trx_id")
                    i.el-icon-info(slot="reference")
                span(v-else-if="scope.row.payment === 'creditcard'") 信用卡支付
                span(v-else-if="scope.row.payment === 'transfer'") 轉帳支付
                el-dropdown(
                  v-if="(scope.row.canChangePaid || isUnlimitedAppointmentRole) && paidCanChange(scope.row.payment)"
                  @command="updatePayment(scope.row, $event)", trigger="click")
                  el-button.dropdown-button(icon="el-icon-arrow-down", size="mini")
                  el-dropdown-menu(slot="dropdown")
                    el-dropdown-item(command='notpaid') 尚未付款
                    el-dropdown-item(command='cash') 現金支付
                    el-dropdown-item(command='transfer') 轉帳支付
                    el-dropdown-item(command='creditcard') 信用卡
        el-table-column(label="個案記錄", width="100")
          template(slot-scope="scope")
            span.cancel-text(v-if="scope.row.isCancelled") 個案已取消
            span(v-else-if="scope.row.has_record")
              //- 進階個管師不在預約所屬專案的可查看清單時，後端不給 record，只顯示已完成
              template(v-if="canDownloadResult && scope.row.record")
                .link-text.text-clickable.flex.align-center.gap-4(@click="tryDownload(scope.row.record.url)")
                  img(:src="successLogo")
                  span 下載紀錄
              template(v-else)
                img(:src="successLogo")
              //- 發佈後被修改過的個案記錄，admin 可查看異動紀錄
              .link-text.text-clickable.font-size-12(
                v-if="isAdmin && scope.row.record_modified_count > 0"
                @click="showRecordLogs(scope.row)") 已修改 {{ scope.row.record_modified_count }} 次
            i.el-icon-error.danger-color(v-else)
        el-table-column(label="支援報備", width="60")
          template(slot-scope="scope")
            template(v-if="scope.row.need_noted && !scope.row.isCancelled")
              //- 點擊圖示切換報備狀態
              el-tooltip(:content="scope.row.noted ? '已完成報備，點擊取消' : '尚未報備，點擊設定為已報備'", placement="top")
                span.clickable(@click="checkNoted(scope.row, $event)")
                  i.el-icon-success.success-color(v-if="scope.row.noted")
                  i.el-icon-error.danger-color(v-else)
            template(v-else)
              span --
        el-table-column(label="操作", width="60")
          template(slot-scope="scope")
            el-dropdown(
              @command="execCommand($event, scope.row)"
            )
              el-button.dropdown-button(icon="el-icon-arrow-down", size="mini")
              el-dropdown-menu(slot="dropdown")
                template(v-if="!scope.row.isCancelled")
                  el-dropdown-item(command="send") 傳送訊息給此個案
                  el-dropdown-item(command="edit"
                    :disabled="!scope.row.canEdit && !isUnlimitedAppointmentRole") 編輯預約
                el-dropdown-item(command="editNote") 編輯備註
                template(v-if="!scope.row.isCancelled")
                  el-dropdown-item(
                    command="uploadReceipt") 上傳自訂收據
                  el-dropdown-item(
                    v-if="!scope.row.receipt"
                    :disabled="!scope.row.receipt"
                    command="downloadReceipt") 下載此筆付款收據(未生成)
                  el-dropdown-item(
                    v-if="scope.row.receipt"
                    command="downloadReceipt") 下載此筆付款收據
                  el-dropdown-item(
                    :disabled="scope.row.location_type === 'inhouse' || scope.row.location_type === 'phone'", command="copyLink") 複製諮商連結
                  el-dropdown-item(
                    command="recreateAppointment") 續約
                  el-dropdown-item(command="cancel"
                    :disabled="!scope.row.canCancel && !isUnlimitedAppointmentRole") 取消此預約記錄
                template(v-if="scope.row.isCancelled && isAdmin")
                  el-dropdown-item(command="restore") 恢復已取消預約
    .pagination.flex.align-center.justify-end
      el-pagination(
        layout="total, sizes, prev, pager, next, ->, jumper"
        :page-size.sync="limit"
        :current-page.sync="currentPage"
        :total="total"
        :page-sizes="[50, 100, 200]"
        @current-change="loadData"
      )
  record-log-viewer(ref="recordLogViewer", append-to-body)
  person-viewer(
    ref="personViewer"
    @showDetail="showDetail"
  )
  appointment-new(
    ref="appointmentNew"
    @finish="loadData"
  )
  appointment-edit(
    ref="appointmentEdit"
    @finish="loadData"
  )
  appointment-creator(
    ref="appointmentCreator", :append-to-body="true"
    @finish="loadData")
  el-dialog(
    title="上傳自訂收據", :visible.sync="receiptUploadVisible" center
    :before-close="handleCloseReceiptUpload"
  )
    .flex.align-center.justify-center.column.gap-20
      .desc 請上傳 PDF 格式的收據檔案
      span.danger-color(v-if="showReplaceAlert") 已經有收據檔案，上傳會覆蓋原本的收據
      el-upload(
        ref="uploader"
        drag
        action=""
        :auto-upload="false"
        :on-change="handleAddReceiptFile"
        :on-remove="handleRemoveReceiptFile"
        :limit="1"
        accept=".pdf"
      )
        i.el-icon-upload
        div 點擊或拖曳檔案到此處上傳
        div.el-upload__tip 支援 PDF 格式
      el-checkbox(v-model="sendReceiptNotification") 寄出收據通知
      el-button(type="primary", @click="uploadReceipt", :disabled="!receiptFile") 確認上傳
</template>

<script>
import { mapGetters } from 'vuex';
import { getTags } from '@/api/tags';
import {
  getAppointments,
  updateAppointmentTags,
  updatePayment,
  cancelAppointment,
  restoreAppointment,
  setAppointmentNoted,
  updateAppointmentNote,
  uploadAppointmentReceipt,
} from '@/api/reserve';
import {
  getUser,
} from '@/api/user';
import { getOrganizations } from '@/api/project';
import successLogo from '@/assets/logo/success.svg';
import PersonViewer from '@/components/drawers/PersonViewer.vue';
import AppointmentNew from '@/components/drawers/AppointmentNew.vue';
import AppointmentEditor from '@/components/drawers/AppointmentEdit.vue';
import AppointmentCreate from '@/components/drawers/AppointmentCreate.vue';
import RecordLogViewer from '@/components/drawers/RecordLogViewer.vue';
import constant from '@/util/constant';
import NameSpan from '@/components/NameSpan.vue';

export default {
  components: {
    PersonViewer,
    'appointment-edit': AppointmentEditor,
    'appointment-new': AppointmentNew,
    'appointment-creator': AppointmentCreate,
    'name-span': NameSpan,
    'record-log-viewer': RecordLogViewer,
  },
  data() {
    return {
      times: [],
      branch: undefined,
      reserveList: [],
      tags: [],

      userFilter: undefined,
      proFilter: undefined,
      userSearch: false,
      proSearch: false,

      total: 10,
      currentPage: 1,
      limit: 100,
      filter: {},

      successLogo,
      detailUser: undefined,
      projectOrgMap: {},
      organizations: [],
      project: undefined,
      hideCancel: false,

      showReplaceAlert: false,
      receiptUploadVisible: false,
      receiptFile: undefined,
      receiptUploadAppointmentID: undefined,
      sendReceiptNotification: true,
    };
  },
  computed: {
    ...mapGetters(['isAdmin', 'isAdvStaff', 'isAccounting', 'isUnlimitedAppointmentRole']),
    canDownloadResult() {
      return this.isAdmin || this.isAdvStaff || this.isAccounting;
    },
  },
  watch: {
    limit() {
      this.currentPage = 1;
      this.loadData();
    },
  },
  methods: {
    handleCloseReceiptUpload(done) {
      this.showReplaceAlert = false;
      this.receiptUploadAppointmentID = undefined;
      this.receiptFile = undefined;
      this.sendReceiptNotification = true;
      if (this.$refs.uploader) {
        this.$refs.uploader.clearFiles();
      }
      done();
    },
    uploadReceipt() {
      this.$execWithLoading(async () => {
        await uploadAppointmentReceipt(this.receiptUploadAppointmentID, this.receiptFile, this.sendReceiptNotification);
        this.$showSuccess('上傳成功');
        if (this.$refs.uploader) {
          this.$refs.uploader.clearFiles();
        }
        this.receiptUploadVisible = false;
        this.loadData();
      }, (e) => {
        console.log(e);
        this.$showAxiosException('上傳失敗', e);
      });
    },
    handleAddReceiptFile(file) {
      this.receiptFile = file.raw;
    },
    handleRemoveReceiptFile() {
      this.receiptFile = undefined;
    },
    checkNoted(data, ev) {
      ev.stopPropagation();
      ev.preventDefault();
      this.$execWithLoading(async () => {
        await setAppointmentNoted(data.id, !data.noted);
        this.$showSuccess(!data.noted ? '已設定完成報備' : '已取消完成報備');
        // eslint-disable-next-line no-param-reassign
        data.noted = !data.noted;
      }, (e) => {
        console.log(e);
        this.$showAxiosException('設定報備狀態失敗', e);
      });
    },
    showRecordLogs(appointment) {
      this.$refs.recordLogViewer.$emit('show', {
        id: appointment.id,
        subtitle: `${appointment.user?.family_name || ''}${appointment.user?.given_name || ''}｜${this.$timestampToDateTimeMinute(appointment.start_at)}`,
      });
    },
    tryDownload(url) {
      this.$goLink(url);
      // try download will met CORS problem
      // this.$execWithLoading(async () => {
      //   await axios.get(url);
      //   this.$goLink(url);
      // }, () => {
      //   this.$showError('檔案尚未準備完成，請稍候下載');
      // });
    },
    editProSearch() {
      this.proSearch = true;
      this.$nextTick(() => {
        this.$refs.proPicker.$emit('focus');
      });
    },
    execCommand(cmd, appointment) {
      if (cmd === 'edit') {
        this.$refs.appointmentEdit.$emit('show', appointment);
      } else if (cmd === 'cancel') {
        this.cancelAppointment(appointment);
      } else if (cmd === 'restore') {
        this.restoreAppointment(appointment);
      } else if (cmd === 'send') {
        this.tryOpenChat(appointment.user.id);
      } else if (cmd === 'copyLink') {
        this.$copy(appointment.meeting_link, true);
      } else if (cmd === 'downloadReceipt') {
        this.$goLink(appointment.receipt_url || appointment.receipt);
      } else if (cmd === 'editNote') {
        this.openNoteEdit(appointment);
      } else if (cmd === 'recreateAppointment') {
        this.$refs.appointmentCreator.$emit('show', {
          user: appointment.user,
          renew: true,
        });
      } else if (cmd === 'uploadReceipt') {
        this.receiptUploadAppointmentID = appointment.id;
        this.showReplaceAlert = (appointment.receipt !== undefined);
        this.receiptFile = undefined;
        this.receiptUploadVisible = true;
      }
    },
    async openNoteEdit(appointment) {
      let keyDownEvent;
      const checkIsEnter = (e) => {
        keyDownEvent = e;
      };
      window.addEventListener('keydown', checkIsEnter, {
        capture: true,
      });
      const result = await this.$prompt('請輸入備註', '備註編輯', {
        confirmButtonText: '儲存',
        cancelButtonText: '取消',
        inputValue: appointment.note,
        closeOnClickModal: false,
        closeOnHashChange: false,
        beforeClose: (action, instance, done) => {
          if (!keyDownEvent) {
            done();
          }
          if (keyDownEvent?.keyCode === 13 && instance.$el.contains(keyDownEvent.target)) {
            keyDownEvent = undefined;
            return;
          }
          done();
        },
      });
      window.removeEventListener('keydown', checkIsEnter, {
        capture: true,
      });
      this.$execWithLoading(async () => {
        await updateAppointmentNote(appointment.id, result.value);
        // eslint-disable-next-line no-param-reassign
        appointment.note = result.value;
        this.$forceUpdate();
        this.$showSuccess('更新備註成功');
      }, (e) => {
        this.$showAxiosException('更新備註失敗', e);
      });
    },
    async tryOpenChat(userID) {
      return this.$execWithLoading(async () => {
        const data = await getUser(userID);
        if (data.line_chat_id && data.line_chat_id !== '') {
          this.$goLink(`${constant.lineChatURL}/${data.line_chat_id}`);
        } else {
          this.$showError('該使用者尚未設定 LINE 聊天 ID');
        }
      }, (e) => this.$showAxiosException('讀取個案資料失敗', e));
    },
    async cancelAppointment(appointment) {
      this.$confirm('確定要取消此預約嗎').then(
        () => this.$execWithLoading(async () => {
          await cancelAppointment(appointment.id);
          this.$showSuccess('已取消預約');
          this.loadData();
        }, (e) => this.$showAxiosException('取消預約失敗', e)),
      ).catch(() => {});
    },
    async restoreAppointment(appointment) {
      this.$confirm('恢復前請先確認此預約的支付狀態是否正確，確認後預約將恢復為有效', '恢復已取消預約', {
        confirmButtonText: '確認恢復',
        cancelButtonText: '取消',
      }).then(
        () => this.$execWithLoading(async () => {
          await restoreAppointment(appointment.id);
          this.$showSuccess('已恢復預約');
          this.loadData();
        }, (e) => {
          if (e?.response?.status === 409) {
            this.$showError('恢復預約失敗，該時段的房間、心理師、個案或 partner 已被其他預約佔用');
          } else {
            this.$showAxiosException('恢復預約失敗', e);
          }
        }),
      ).catch(() => {});
    },
    showDetail(user) {
      this.$root.$emit('show-user', user);
    },
    paidCanChange(payment) {
      return ['notpaid', 'cash', 'transfer', 'creditcard'].indexOf(payment) >= 0;
    },
    showCase(data) {
      this.$refs.personViewer.$emit('show', {
        type: 'id',
        data: data.id || data.user.id,
      });
    },
    getFilter() {
      if (!this.times || this.times.length === 0) {
        this.times = this.getDefaultTime();
      }
      const [start, end] = this.times;
      end.setHours(23, 59, 59, 999);
      const filter = {
        start_at: parseInt(start.getTime() / 1000, 10),
        end_at: parseInt(end.getTime() / 1000, 10),
        branch: (this.branch !== '' && this.branch) ? this.branch : undefined,
        page: this.currentPage - 1,
        limit: this.limit,
        hide_cancel: this.hideCancel,
      };
      if (this.userFilter) {
        filter.user_id = this.userFilter;
      }
      if (this.proFilter) {
        filter.professional_id = this.proFilter;
      }
      if (this.project) {
        if (this.project === 'null') {
          filter.project = 'null';
        } else {
          filter.project = parseInt(this.project, 10);
        }
      }
      return filter;
    },
    changeDate() {
      this.page = 1;
      this.$execWithLoading(async () => {
        await this.loadReserveList();
      }, (e) => this.$showAxiosException('讀取預約清單失敗', e));
    },
    loadData() {
      this.$execWithLoading(async () => {
        this.reserveList = [];
        const rsps = await Promise.all([
          this.getOrganizations(),
          this.loadTags(),
          this.loadReserveListFromAPI(),
        ]);
        this.parseAPIReserves(rsps[2]);
      }, (e) => this.$showAxiosException('讀取預約清單失敗', e));
    },
    async getOrganizations() {
      const rsp = await getOrganizations();
      this.projectOrgMap = {};
      rsp.forEach((org) => {
        org.projects.forEach((p) => {
          this.projectOrgMap[p.id] = org;
        });
        // eslint-disable-next-line no-param-reassign
        org.projects = org.projects.filter((p) => p.public);
      });
      this.organizations = rsp;
    },
    async loadReserveListFromAPI() {
      return getAppointments(this.getFilter());
    },
    parseAPIReserves(reserve) {
      let reserveList = reserve;
      const tagMap = this.tags.reduce((ret, t) => {
        // eslint-disable-next-line no-param-reassign
        ret[t.name] = t.public;
        return ret;
      }, {});
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const todayTs = parseInt(today.getTime() / 1000, 10);

      const now = new Date();
      const nowTs = parseInt(now.getTime() / 1000, 10);

      const { meta } = reserveList;
      if (reserveList.appointments) {
        reserveList = reserveList.appointments;
        this.total = meta.total || 0;
      }
      this.reserveList = reserveList.map((r) => ({
        ...r,
        tags: r.tags.filter((t) => tagMap[t]),
        length: ((r.end_at - r.start_at) / 3600).toFixed(1),
        isCancelled: r.status === 'cancelled',
        type: r.appointment_type || r.type || '',
        subtype: r.appointment_subtype || r.subtype || 'statutoryagents',
        projectName: r.project ? this.projectOrgMap[r.project.id].name : '',
        canEdit: r.start_at >= todayTs,
        canCancel: nowTs < r.end_at + 86400,
        canChangePaid: nowTs < r.end_at + 2 * 86400,
        need_note: r.professional.branches.findIndex((v) => v.id === r.room.branch.id) < 0,
      }));
    },
    async loadReserveList() {
      this.reserveList = [];
      const reserves = await this.loadReserveListFromAPI();
      this.parseAPIReserves(reserves);
    },
    async loadTags() {
      const tags = await getTags();
      this.tags = tags;
    },
    async updateBranchTags(branch) {
      return this.$execWithLoading(async () => {
        await updateAppointmentTags(branch.id, branch.tags);
        this.$showSuccess('已更新標記');
      }, () => {
        this.$showError('更新標記失敗');
        this.loadData();
      });
    },
    changeBranch() {
      this.currentPage = 1;
      this.loadData();
    },
    changeProject() {
      this.currentPage = 1;
      this.loadData();
    },
    setUserSearch(u) {
      if (u === undefined) {
        this.userSearch = false;
        this.userFilter = undefined;
      } else {
        // this.userFilter = `${u.family_name}${u.given_name}`;
        // this.userFilter = `${u.given_name}`;
        this.userFilter = u.id;
      }
      this.currentPage = 1;
      this.loadData();
    },
    setProFilter(p) {
      if (p === undefined) {
        this.proSearch = false;
        this.proFilter = undefined;
      } else {
        // this.proFilter = `${p.family_name}${p.given_name}`;
        // this.proFilter = `${p.given_name}`;
        this.proFilter = p.id;
      }
      this.currentPage = 1;
      this.loadData();
    },
    updatePayment(appointment, method) {
      this.$execWithLoading(async () => {
        await updatePayment(appointment.id, method);
        // eslint-disable-next-line no-param-reassign
        appointment.payment = method;
        this.$showSuccess('更新成功');
      }, () => {
        this.$showError('更新失敗，請稍後再試');
      });
    },
    changeSearchUser() {
      this.userFilter = undefined;
    },
    getDefaultTime() {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const start = new Date(now.getTime());
      const end = new Date(now.getTime() + 7 * 86400 * 1000);
      end.setHours(0, 0, 0, 0);
      return [start, end];
    },
  },
  mounted() {
    this.times = this.getDefaultTime();
    setTimeout(() => {
      this.loadData();
    }, 10);
  },
};
</script>

<style lang="scss" scoped>
.reserve-page {
  position: relative;
  padding: 30px 0;
  .search-bar {
    padding: 0 30px;
    .filter {
      .column {
        .title {
          font-size: 12px;
        }
        .date-range-input {
          width: 440px;
        }
        .place-input {
          width: 300px;
        }
      }
    }
  }
  .table {
    flex: 1;
    .record-link {
      text-decoration: none;
    }
  }
  .pagination {
    flex: 0 0 auto;
  }
  .empty {
    padding: 0 30px;
    margin-top: 20px;
  }
}
</style>

<style lang="scss">
@import '@/assets/style/variables.scss';

.reserve-page {
  & > .table {
    margin: 0 30px;
    overflow: hidden;
    .td-tags {
      .cell {
        display: flex;
        gap: 6px;
        flex-wrap: wrap;
      }
    }
    .td-name {
      color: $primary-color;
    }
  }

  // hack
  .el-table {
    border: 1px solid #EBEEF5;
    border-bottom: none;
    border-left: none;
    display: flex;
    flex-direction: column;
    .el-table__header {
      thead {
        tr {
          th {
            background: #E6F4F4;
            border-left: 1px solid #EBEEF5;
          }
        }
      }
    }
    .el-table__body {
      tbody {
        tr {
          td {
            border-left: 1px solid #EBEEF5;
          }
        }
      }
    }

    // handle scroll
    .el-table__header-wrapper {
      flex: 0 0 auto;
    }
    .el-table__body-wrapper {
      flex: 1;
      overflow: overlay;
    }
  }
  .dropdown-button {
    padding: 7px;
  }
  .cancel-text {
    pointer-events: none;
    color: $text-placeholder-color;
  }
  .cancel-text-with-event {
    color: $text-placeholder-color;
  }
}
</style>
